import { Injectable } from '@angular/core';

import { InitConstant, MessageConstant } from '../Constant';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class ProfileService
{
    private display_name = "";
    private uid = "";
    private email = "";
    private profile_icon = InitConstant.PROFILE_EMPTY_ICON;
    private oco_uid = "";
    private my_device_id = "";
    private devices = [];
    private is_loaded = false;
    private is_success = 0;

    constructor(
        private api: ApiService,
        private auth: AuthService,
        private log: LogService
    )
    {
    }

    async getProfiles()
    {
        if (this.isLoaded() === true) return;

        this.is_success = 0;

        if (await this.getIcon() === true) {
            this.is_success++;
        }
        if (await this.getProfile() === true) {
            this.is_success++;
        }

        if (this.is_success == 2) {
            this.setLoaded(true);
        }
    }

    async getProfile()
    {
        this.devices = [];

        const data = await this.api.profile();
        if (this.api.isSuccess('profile')) {
            this.display_name = data['display_name'];
            this.uid = data['uid'];
            this.email = data['email'];
            this.oco_uid = this.uid.substr(0, 1);
            this.my_device_id = data['my_device_id'];

            if (data['devices'].length > 0) {
                for (let device of data['devices']) {
                    this.devices.push(device);
                }
            }

            return true;
        } else {
            this.display_name = "";
            this.uid = "";
            this.email = "";
            this.oco_uid = "";
            this.my_device_id = "";

            return false;
        }
    }

    async getIcon()
    {
        const blob = await this.api.profileicon();

        if (this.api.isSuccess('profileicon')) {
            const url = window.URL.createObjectURL(blob);
            this.profile_icon = `background-image: url(${url});`;
        } else {
            this.profile_icon = InitConstant.PROFILE_EMPTY_ICON;

            if (!this.api.isNotfoundErr('profileicon')) {
                return false;
            }
        }

        return true;
    }

    setLoaded(is_loaded)
    {
        this.is_loaded = is_loaded; 
    }

    isLoaded()
    {
        return this.is_loaded; 
    }

    getProfileIcon()
    {
        return this.profile_icon; 
    }

    getDisplayName()
    {
        return this.display_name; 
    }

    getUid()
    {
        return this.uid; 
    }

    getEmail()
    {
        return this.email; 
    }

    getOcouid()
    {
        return this.oco_uid.toUpperCase(); 
    }

    getMyDeviceId()
    {
        return this.my_device_id; 
    }

    getDevices()
    {
        return this.devices; 
    }
}
